import Stack from "@/components/layout/stack"
import { Card, CardFooter, CardHeader } from "@/components/ui/card"

interface DashboardCardProps {
  title: string;
  icon: React.ReactNode;
  button: React.ReactNode;
}

export default function DashboardCard({
  title,
  icon,
  button,
}: DashboardCardProps) {
  return (
    <Card className="justify-between flex-1 gap-2">
      <CardHeader>
        <Stack align="start">
          {icon}
          {title}
        </Stack>
      </CardHeader>
      <CardFooter className="gap-2">{button}</CardFooter>
    </Card>
  )
}
